<template>
  <layout :tenantId="tenantId">
    <main id="InfoSection">
      <h1>{{ t('InfoPageHeading') }}</h1>
      
      <localizedInfoSection sectionName="InfoPage">
        <template v-if="infoPageDetails?.privacyPolicyUrl && infoPageDetails?.privacyPolicyUrl.length > 0" >
          <h1> {{t('PrivacyPolicy')}} </h1>
          <p><a :href="infoPageDetails?.privacyPolicyUrl" target="_blank">{{t('OpenPrivacyPolicy')}}</a></p>
        </template>

        <template v-if="infoPageDetails?.showAccessibilityStatement" >
          <h1> {{ t('AccessibilityPageHeading') }} </h1>
          <p><router-link :to="{ name: 'accessibility', params : {tenantId: tenantId}, query: {lang: locale}}"> {{ t('OpenAccessibilityStatement') }}</router-link></p>
        </template>

        <template v-if="infoPageDetails?.feedbackUrl && infoPageDetails?.feedbackUrl.length > 0" >
          <h1> {{t('InfoPageFeedbackUrlHeader')}} </h1>
          <p><a :href="infoPageDetails?.feedbackUrl" target="_blank">{{ t('OpenInfoPageFeedbackUrl') }}</a></p>
        </template>
      </localizedInfoSection>

      <localizedInfoSection sectionName="ManualPage" />
    </main>
    
  </layout>
</template>

<script src="./info.ts"></script>
<style src="./sign2.css"/>
